import React from 'react';
import { IconRoundedWarning } from '../../assets/icons/IconRoundedWarning';
import type { ReliabilityNoticeLineProps } from './types';

// Deliberately quiet: the same subdued grey as the daily-loading checklist, so it reads as a footnote to
// the greeting rather than an alert competing with the relance list.
export const ReliabilityNoticeLine: React.FC<ReliabilityNoticeLineProps> = ({ children, testId }) => (
    <p data-testid={testId} className="flex items-start gap-s text-m font-medium text-content-subtle">
        <span className="flex h-lh shrink-0 items-center">
            <IconRoundedWarning className="size-4 text-icon-muted" />
        </span>
        <span data-testid={`${testId}-message`}>{children}</span>
    </p>
);
